export default "__VITE_ASSET__mPx_UEaL__"